export default "__VITE_ASSET__CZDZc$aQ__"